<template>
    <span class="actions d-flex">
        <!-- Nouveau système avec feature flag : bouton unique "Associer" -->
        <span v-if="object.status == 0 && object.hasEmailLicenceFeature && useDvFlagAccess('beepiz-licence-unassociated-can:create')" class="d-flex">
            <Button2 @click.native.prevent="handleAssociate">
                {{ $t('device.registrations.associate_button_label') }}
            </Button2>
        </span>
        <!-- Ancien système (sans feature flag) : boutons multiples selon le statut -->
        <span v-else-if="object.status == 0 && !object.hasEmailLicenceFeature" class="d-flex">
            <i class="fa fa-send fa-fw" :title="$t('device.registrations.tooltips.sendSMS')" v-if="useDvFlagAccess('beepiz-licence-unassociated-can:create')" @click.stop="handleSendFirstTime"></i>
            <i class="fa fa-qrcode fa-fw" :title="$t('device.registrations.tooltips.sendQRCode')" v-if="useDvFlagAccess('beepiz-licence-unassociated-can:create')" @click.stop="handleQRCode"></i>
        </span>
        <span v-else-if="object.status == 1" class="d-flex">
            <i v-if="object.registration.type_association === 'qrcode' && useDvFlagAccess('beepiz-licence-unassociated-can:update')" class="fa fa-qrcode fa-fw" :title="$t('device.registrations.tooltips.showQrCode')" @click.stop="handleQRCode"></i>
            <i v-else-if="object.registration.type_registration !== 'qrcode' && useDvFlagAccess('beepiz-licence-unassociated-can:update')" class="fa fa-send fa-fw" :title="$t('device.registrations.tooltips.sendAgain')" @click.stop="handleSend"></i>
            <i class="fa fa-ban fa-fw" :title="$t('device.registrations.tooltips.cancel')" v-if="useDvFlagAccess('beepiz-licence-unassociated-can:delete')" @click.stop="handleCancel"></i>
        </span>
        <span v-else-if="object.status == 3" class="d-flex">
            <i class="fa fa-send fa-fw" :title="$t('device.registrations.tooltips.sendAgain')" v-if="useDvFlagAccess('beepiz-licence-unassociated-can:update')" @click.stop="handleSend"></i>
            <i class="fa fa-ban fa-fw" :title="$t('device.registrations.tooltips.cancel')" v-if="useDvFlagAccess('beepiz-licence-unassociated-can:delete')" @click.stop="handleCancel"></i>
        </span>
    </span>
</template>

<script>
    import Button2 from "@/components/ui/Button2.vue";
    import {useDvFlagAccess} from "../../../services/featureFlag";

    export default {
        name: 'statusrenderer',
        components: {
            Button2,
        },
        props: {
            object: {
                type: Object,
                required: true
            }
        },
        data: () => ({

        }),
        methods: {
          useDvFlagAccess,
            handleQRCode: function () {
                this.$emit('qrcode',this.object);
            },
            handleCancel: function () {
                this.$emit('cancel',this.object);
            },
            handleSend: function () {
                this.$emit('send',this.object);
            },
            handleSendFirstTime: function () {
                this.$emit('sendfirsttime',this.object);
            },
            handleAssociate: function () {
                this.$emit('associate',this.object);
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
